import { IAction } from '~/src/store';

import { ETicketPayment } from './index';

export type TSetPaymentSumIsLoading = IAction<ETicketPayment.SET_PAYMENT_SUM_IS_LOADING, boolean>

const setPaymentSumIsLoading = (status: boolean): TSetPaymentSumIsLoading => ({
    type: ETicketPayment.SET_PAYMENT_SUM_IS_LOADING,
    payload: status,
});

export default setPaymentSumIsLoading;
